import React, { useState, useEffect } from "react";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import Defaultloadinggif from "../../../../layout/Others/Defaultloadinggif";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";

const LivekitConfiguration = () => {
    const { fetchRequest } = useMyContext();
    const baseURL = process.env.REACT_APP_Baseurl;
    const apiIndex = `${baseURL}/admin/livekit-configuration/index`;
    const apiStore = `${baseURL}/admin/livekit-configuration/store`;

    const [loading, setLoading] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);

    const [formData, setFormData] = useState({
        livekit_api_key: "",
        livekit_api_secret: "",
        livekit_url: "",
        livekit_egress_s3_bucket: "",
        livekit_egress_s3_prefix: "",
        livekit_egress_s3_region: "",
        livekit_egress_s3_endpoint: "",
        livekit_egress_s3_access_key: "",
        livekit_egress_s3_secret_key: "",
        status: 1
    });

    useEffect(() => {
        const loadSettings = async () => {
            setLoading(true);
            try {
                const response = await fetchRequest({
                    method: 'GET',
                    url: apiIndex,
                });
                if (response?.status && response?.livekitConfiguration) {
                    const data = response.livekitConfiguration;
                    setFormData({
                        livekit_api_key: data.livekit_api_key || "",
                        livekit_api_secret: data.livekit_api_secret || "",
                        livekit_url: data.livekit_url || "",
                        livekit_egress_s3_bucket: data.livekit_egress_s3_bucket || "",
                        livekit_egress_s3_prefix: data.livekit_egress_s3_prefix || "",
                        livekit_egress_s3_region: data.livekit_egress_s3_region || "",
                        livekit_egress_s3_endpoint: data.livekit_egress_s3_endpoint || "",
                        livekit_egress_s3_access_key: data.livekit_egress_s3_access_key || "",
                        livekit_egress_s3_secret_key: data.livekit_egress_s3_secret_key || "",
                        status: data.status ?? 1
                    });
                }
            } catch (error) {
                // If 404, it might just mean no settings saved yet, don't show error toast for initial load
                if (error?.response?.status !== 404) {
                    toast.error(error?.response?.data?.message || "Failed to load settings");
                }
            } finally {
                setLoading(false);
            }
        };
        loadSettings();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        setShowOverlay(true);
        try {
            const response = await fetchRequest({
                method: 'POST',
                url: apiStore,
                data: formData,
            });
            if (response?.status) {
                toast.success(response.message || "Settings saved successfully");
            } else {
                toast.error(response?.message || "Failed to save settings");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setShowOverlay(false);
        }
    };

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />;
    }

    return (
        <>
            {showOverlay && (<Response_Processing />)}
            <AdminBackNavigation text="Back" path="/settings" />
            <AdminSaveHeader heading={"LiveKit Configuration"} saveText={"Save Settings"} saveMethod={handleSave} loading={showOverlay} />

            <FormContainer>
                <Wrapper className="w-100">
                    <MessageHeading text="LiveKit Server Settings" />
                    <div className="row mb-4">
                        <div className="col-md-12 mb-3">
                            <MessageLabel text="LiveKit URL" />
                            <AdminCustomInput
                                type="text"
                                name="livekit_url"
                                value={formData.livekit_url}
                                onChange={handleChange}
                                placeHolder="wss://your-livekit-server.livekit.cloud"
                            />
                            <small className="text-muted">WebSocket URL for LiveKit server connections.</small>
                        </div>
                        <div className="col-md-6 mb-3">
                            <MessageLabel text="LiveKit API Key" />
                            <AdminCustomInput
                                type="text"
                                name="livekit_api_key"
                                value={formData.livekit_api_key}
                                onChange={handleChange}
                                placeHolder="Enter LiveKit API Key"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <MessageLabel text="LiveKit API Secret" />
                            <AdminCustomInput
                                type="password"
                                name="livekit_api_secret"
                                value={formData.livekit_api_secret}
                                onChange={handleChange}
                                placeHolder="Enter LiveKit API Secret"
                            />
                        </div>
                    </div>

                    <MessageHeading text="LiveKit Recording (Egress) - S3 Configuration" />
                    <div className="row mb-4">
                        <div className="col-md-6 mb-3">
                            <MessageLabel text="S3 Bucket Name" />
                            <AdminCustomInput
                                type="text"
                                name="livekit_egress_s3_bucket"
                                value={formData.livekit_egress_s3_bucket}
                                onChange={handleChange}
                                placeHolder="your-bucket-name"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <MessageLabel text="S3 Prefix (Folder)" />
                            <AdminCustomInput
                                type="text"
                                name="livekit_egress_s3_prefix"
                                value={formData.livekit_egress_s3_prefix}
                                onChange={handleChange}
                                placeHolder="recordings/"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <MessageLabel text="S3 Region" />
                            <AdminCustomInput
                                type="text"
                                name="livekit_egress_s3_region"
                                value={formData.livekit_egress_s3_region}
                                onChange={handleChange}
                                placeHolder="us-east-1"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <MessageLabel text="S3 Endpoint" />
                            <AdminCustomInput
                                type="text"
                                name="livekit_egress_s3_endpoint"
                                value={formData.livekit_egress_s3_endpoint}
                                onChange={handleChange}
                                placeHolder="https://s3.amazonaws.com"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <MessageLabel text="S3 Access Key" />
                            <AdminCustomInput
                                type="text"
                                name="livekit_egress_s3_access_key"
                                value={formData.livekit_egress_s3_access_key}
                                onChange={handleChange}
                                placeHolder="Enter S3 Access Key"
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <MessageLabel text="S3 Secret Key" />
                            <AdminCustomInput
                                type="password"
                                name="livekit_egress_s3_secret_key"
                                value={formData.livekit_egress_s3_secret_key}
                                onChange={handleChange}
                                placeHolder="Enter S3 Secret Key"
                            />
                        </div>
                    </div>

                    {/* <div className="row mb-3">
                        <div className="col-md-6">
                            <MessageLabel text="Feature Status" />
                            <select
                                className="form-select theme-bg-color text-color"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value={1}>Enabled</option>
                                <option value={0}>Disabled</option>
                            </select>
                        </div>
                    </div> */}

                    <div className="d-flex justify-content-end mt-4">
                        <AdminCustomButton id="livekit-config-save" className="px-3 py-1 m-0" saveMethod={handleSave} saveText="Save Settings" />
                    </div>
                </Wrapper>
            </FormContainer>
        </>
    );
};

export default LivekitConfiguration;